/**
 * @generated SignedSource<<eae0caf60d501468f00c97677c325117>>
 * @relayHash dce043bf215d0738fb2f0c558281922b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f75688f1ae1ca933842d545c9d503ba5b6f3c6d424bd556ae0e143e549031217

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GrowthUnifiedProfileProductEdition = "ENTERPRISE" | "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type freeChooseYourEditionModalQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type freeChooseYourEditionModalQuery$data = {
  readonly confluence_storage: {
    readonly bytesLimit: AGG$Long | null | undefined;
    readonly bytesUsed: AGG$Long;
    readonly isUnlimited: boolean | null | undefined;
  } | null | undefined;
  readonly growthUnifiedProfile_getUnifiedProfile: {
    readonly sites: ReadonlyArray<{
      readonly products: ReadonlyArray<{
        readonly nbeRecommendation: {
          readonly edition: GrowthUnifiedProfileProductEdition | null | undefined;
          readonly recommendationDate: string | null | undefined;
        } | null | undefined;
        readonly productName: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingPremium: {
            readonly experienceUrl: string | null | undefined;
          } | null | undefined;
          readonly compareOfferingsPremiumHighlighted?: {
            readonly experienceUrl: string | null | undefined;
          } | null | undefined;
          readonly compareOfferingsStandardHighlighted?: {
            readonly experienceUrl: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type freeChooseYourEditionModalQuery = {
  response: freeChooseYourEditionModalQuery$data;
  variables: freeChooseYourEditionModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Premium"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "compareOfferingsStandardHighlighted",
      "args": [
        {
          "kind": "Literal",
          "name": "input",
          "value": {
            "highlightedOffering": {
              "offeringName": "Standard"
            }
          }
        }
      ],
      "concreteType": "CcpCompareOfferingsExperienceCapability",
      "kind": "LinkedField",
      "name": "compareOfferings",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": "compareOfferings(input:{\"highlightedOffering\":{\"offeringName\":\"Standard\"}})"
    },
    {
      "alias": "compareOfferingsPremiumHighlighted",
      "args": [
        {
          "kind": "Literal",
          "name": "input",
          "value": {
            "highlightedOffering": {
              "offeringName": "Premium"
            }
          }
        }
      ],
      "concreteType": "CcpCompareOfferingsExperienceCapability",
      "kind": "LinkedField",
      "name": "compareOfferings",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": "compareOfferings(input:{\"highlightedOffering\":{\"offeringName\":\"Premium\"}})"
    }
  ],
  "type": "CcpEntitlementExperienceCapabilities"
},
v7 = {
  "concreteType": "ConfluenceStorage",
  "kind": "LinkedField",
  "name": "confluence_storage",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isUnlimited"
    },
    {
      "kind": "ScalarField",
      "name": "bytesUsed"
    },
    {
      "kind": "ScalarField",
      "name": "bytesLimit"
    }
  ]
},
v8 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "cloudId"
    }
  ],
  "concreteType": "GrowthUnifiedProfileResult",
  "kind": "LinkedField",
  "name": "growthUnifiedProfile_getUnifiedProfile",
  "plural": false,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileSiteDetails",
      "kind": "LinkedField",
      "name": "sites",
      "plural": true,
      "selections": [
        {
          "concreteType": "GrowthUnifiedProfileProductDetails",
          "kind": "LinkedField",
          "name": "products",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "productName"
            },
            {
              "concreteType": "GrowthUnifiedProfileProductNBE",
              "kind": "LinkedField",
              "name": "nbeRecommendation",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "edition"
                },
                {
                  "kind": "ScalarField",
                  "name": "recommendationDate"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "freeChooseYourEditionModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "changeOfferingPremium",
                        "args": (v3/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      },
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "freeChooseYourEditionModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": "changeOfferingPremium",
                        "args": (v3/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      },
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      },
      (v7/*: any*/),
      (v8/*: any*/)
    ]
  },
  "params": {
    "id": "f75688f1ae1ca933842d545c9d503ba5b6f3c6d424bd556ae0e143e549031217",
    "metadata": {},
    "name": "freeChooseYourEditionModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "240c219ea71360a60cbbdf77a06dbd96";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
